/*! PNM Picker JS — Highlander edition: there can be only one */
(function () {
  'use strict';
  var REQUIRED = 25,
    PICK_LIMIT = 25,
    KEY = 'pnm_picker_picks_v1';
  var BUS = {
    h: {},
    on: function (e, f) {
      (this.h[e] = this.h[e] || []).push(f);
    },
    fire: function (e, a) {
      (this.h[e] || []).forEach(function (f) {
        try {
          f(a);
        } catch (_) {}
      });
    },
  };
  var randomisingAnimation = null;
  var editContext = null;
  var ADVENT_COLLECTION_PREFIX = '/collections/little-wax-melts';
  var ADVENT_PRODUCT_HANDLES = [
    'advent-calendar-pick-your-own',
    'advent-calendar',
    'advent-2025',
    'pick-n-melt-advent',
  ];
  function detectAdventContext() {
    try {
      var path = String(location.pathname || '');
      var m = path.match(/^\/products\/([^\/?#]+)/);
      if (m) {
        for (var i = 0; i < ADVENT_PRODUCT_HANDLES.length; i++) {
          if (ADVENT_PRODUCT_HANDLES[i] === m[1]) return 'product';
        }
      }
      if (/^\/cart(\/|$)/.test(path)) {
        return 'cart';
      }
    } catch (_) {}
    return 'none';
  }
  var ADVENT_CONTEXT = detectAdventContext();
  var scaffoldReady = !1;
  var scaffoldScheduled = !1;
  var searchInputEl = null;
  var searchResultsEl = null;
  var searchRequestToken = 0;
  var searchPrefetching = !1;
  var SEARCH_RESULT_LIMIT = 24;
  var scentsCache = null;
  function qs(s, r) {
    return (r || document).querySelector(s);
  }
  function qsa(s, r) {
    return Array.prototype.slice.call((r || document).querySelectorAll(s));
  }
  function esc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
  function escAttr(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;');
  }
  function stripTags(value) {
    return String(value || '')
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
  function clonePick(p) {
    if (!p || typeof p !== 'object') return null;
    var id = p.id;
    if (typeof id === 'string' && /^\d+$/.test(id)) id = Number(id);
    var image = '';
    if (typeof p.image === 'string') {
      image = p.image;
    } else if (p.image && typeof p.image === 'object' && p.image.src) {
      image = p.image.src;
    } else if (p.featured_image && p.featured_image.src) {
      image = p.featured_image.src;
    }
    var desc = p.desc;
    if (desc == null && typeof p.scent_description === 'string') {
      desc = p.scent_description;
    }
    if (desc == null && typeof p.description === 'string') {
      desc = p.description;
    }
    return {
      id: id,
      title: p.title || p.name || '',
      variant_title: p.variant_title || '',
      image: image,
      handle: p.handle || p.product_handle || '',
      desc: desc || '',
    };
  }
  function emptySlots() {
    var arr = new Array(REQUIRED);
    for (var i = 0; i < REQUIRED; i++) arr[i] = null;
    return arr;
  }
  function normalisePicks(value) {
    var slots = emptySlots();
    if (Array.isArray(value)) {
      if (value.length >= REQUIRED) {
        for (var i = 0; i < REQUIRED; i++) {
          var entry = value[i];
          if (entry && typeof entry === 'object' && entry.id != null) {
            slots[i] = clonePick(entry);
          }
        }
      } else {
        var pos = 0;
        for (var j = 0; j < value.length && pos < REQUIRED; j++) {
          var entry2 = value[j];
          if (entry2 && typeof entry2 === 'object' && entry2.id != null) {
            slots[pos++] = clonePick(entry2);
          }
        }
      }
    }
    return slots;
  }
  function filledCount(picks) {
    var total = 0;
    for (var i = 0; i < REQUIRED; i++) {
      if (picks[i]) total++;
    }
    return total;
  }
  function filledEntries(picks) {
    var out = [];
    for (var i = 0; i < REQUIRED; i++) {
      if (picks[i]) out.push({ slot: i, pick: picks[i] });
    }
    return out;
  }
  function firstEmptySlot(picks) {
    for (var i = 0; i < REQUIRED; i++) {
      if (!picks[i]) return i;
    }
    return -1;
  }
  function load() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY) || '[]');
      var picks = normalisePicks(raw);
      if (!Array.isArray(raw) || raw.length !== REQUIRED) {
        localStorage.setItem(KEY, JSON.stringify(picks));
      }
      return picks;
    } catch (_) {
      var empty = emptySlots();
      try {
        localStorage.setItem(KEY, JSON.stringify(empty));
      } catch (__) {}
      return empty;
    }
  }
  function save(v) {
    var picks = normalisePicks(v || []);
    localStorage.setItem(KEY, JSON.stringify(picks));
  }
  function cleanTitle(t) {
    var suffix = ' - Little Wax Melts';
    var s = String(t || '');
    return s.slice(-suffix.length) === suffix ? s.slice(0, -suffix.length) : s;
  }
  function captureLastCollection() {
    try {
      if (!isAdventMode()) return;
      var m = location.pathname.match(/^\/collections\/([^\/?#]+)/);
      if (m && m[1]) localStorage.setItem('pnm_last_collection', m[1]);
    } catch (_) {}
  }
  function isAdventMode() {
    return ADVENT_CONTEXT === 'collection';
  }
  function hasPickerHost() {
    return !!document.getElementById('pnm-picker-root');
  }
  function parseSelectedScents(value) {
    if (!value && value !== 0) return [];
    var raw = '';
    try {
      raw = String(value).trim();
    } catch (_) {
      raw = '';
    }
    if (!raw) return [];
    var parts = raw.split(/[.,|]/);
    var ids = [];
    for (var i = 0; i < parts.length; i++) {
      var token = parts[i];
      if (!token) continue;
      var id = parseInt(token, 36);
      if (!isNaN(id)) ids.push(id);
    }
    return ids;
  }
  function buildSelectedScentsPayload(chosen) {
    var tokens = [];
    (chosen || []).forEach(function (entry) {
      if (!entry || !entry.pick || entry.pick.id == null) return;
      var num = Number(entry.pick.id);
      if (!isNaN(num)) {
        tokens.push(num.toString(36));
      }
    });
    return tokens.join('.');
  }
  function showLoader() {
    if (document.getElementById('pnm-loader')) return;
    var div = document.createElement('div');
    div.id = 'pnm-loader';
    div.className = 'pnm-loader';
    div.innerHTML = '<div class="pnm-spinner"></div>';
    document.body.appendChild(div);
  }
  function hideLoader() {
    var el = document.getElementById('pnm-loader');
    if (el) el.remove();
  }
  function loadPicksForIds(idList) {
    if (!Array.isArray(idList) || !idList.length) {
      save([]);
      BUS.fire('picks:changed');
      return Promise.resolve();
    }
    showLoader();
    var cachePromise = scentsCache ? Promise.resolve(scentsCache) : getScents();
    return cachePromise
      .then(function (all) {
        hideLoader();
        var byId = {};
        (all || []).forEach(function (v) {
          if (v && v.id != null) byId[String(v.id)] = v;
        });
        var picks = emptySlots();
        var pos = 0;
        for (var i = 0; i < idList.length && pos < REQUIRED; i++) {
          var id = Number(idList[i]);
          if (!id) continue;
          var variant = byId[String(id)];
          if (variant) {
            picks[pos++] = {
              id: id,
              title: cleanTitle(variant.title || '').trim(),
              variant_title: variant.variant_title || '',
              image: variant.image || '',
              handle: variant.product_handle || '',
              desc:
                variant.scent_description ||
                variant.desc ||
                variant.description ||
                '',
            };
          } else {
            picks[pos++] = {
              id: id,
              title: '',
              variant_title: '',
              image: '',
              handle: '',
              desc: '',
            };
          }
        }
        save(picks);
        BUS.fire('picks:changed');
      })
      .catch(function () {
        hideLoader();
      });
  }
  function ensureAdventParam(url) {
    if (!isAdventMode()) return url;
    try {
      var target = new URL(url, location.origin);
      if (target.searchParams.get('ac') !== '1')
        target.searchParams.set('ac', '1');
      return target.origin === location.origin
        ? target.pathname + (target.search || '') + (target.hash || '')
        : target.toString();
    } catch (_) {
      if (!url) return url;
      if (url.indexOf('?') === -1) return url + '?ac=1';
      if (/(?:^|[?&])ac=1(?:&|$)/.test(url)) return url;
      return url + '&ac=1';
    }
  }
  function injectAdventTileStyles() {
    if (!isAdventMode()) return;
    if (qs('#pnm-picker-tiles-style')) return;
    var style = document.createElement('style');
    style.id = 'pnm-picker-tiles-style';
    style.textContent =
      '\
.pnm-picker-trigger{cursor:pointer;background:none;border:0;padding:0;margin:0;display:block;width:100%;text-align:inherit;}\
.pnm-picker-trigger:focus{outline:2px solid #ffa000;outline-offset:2px;}\
.pnm-picker-trigger:focus-visible{outline:2px solid #ffa000;outline-offset:2px;}\
.pnm-picker-card--selectable{cursor:pointer;transition:box-shadow 0.2s ease;}\
.pnm-picker-card--selectable:hover:not(.pnm-picker-card--selected){box-shadow:0 0 0 2px rgba(255,160,0,0.35);}\
.pnm-picker-card--selectable:focus-within{box-shadow:0 0 0 2px rgba(255,160,0,0.45);}\
.pnm-picker-card--selected{box-shadow:0 0 0 2px #ffa000;}\
';
    document.head.appendChild(style);
  }
  function getTilePayload(el) {
    if (!el) return null;
    var node = el;
    while (node && node !== document) {
      if (node.getAttribute && node.getAttribute('data-pnm-pick-id')) break;
      node = node.parentNode;
    }
    if (!node || !node.getAttribute) return null;
    var id = node.getAttribute('data-pnm-pick-id');
    if (!id) return null;
    return {
      id: id,
      title: node.getAttribute('data-pnm-pick-title') || '',
      image: node.getAttribute('data-pnm-pick-image') || '',
      desc: node.getAttribute('data-pnm-pick-desc') || '',
    };
  }
  function updateTileSelections(root) {
    if (!root && !isAdventMode()) return;
    var picks = load();
    var selected = new Set();
    picks.forEach(function (p) {
      if (p && p.id != null) selected.add(String(p.id));
    });
    var scope = root || document;
    if (!scope || !scope.querySelectorAll) return;
    qsa('.pnm-picker-card', scope).forEach(function (card) {
      var baseId = card.getAttribute('data-pnm-pick-id');
      var hasSelection = !1;
      if (baseId && selected.has(String(baseId))) hasSelection = !0;
      qsa('.pnm-picker-trigger', card).forEach(function (trigger) {
        var tid = trigger.getAttribute('data-pnm-pick-id') || baseId;
        var triggerSelected = tid && selected.has(String(tid));
        if (triggerSelected) {
          hasSelection = !0;
          trigger.setAttribute('aria-pressed', 'true');
        } else {
          trigger.removeAttribute('aria-pressed');
        }
      });
      if (hasSelection) {
        card.classList.add('pnm-picker-card--selected');
        card.setAttribute('data-pnm-selected', 'true');
      } else {
        card.classList.remove('pnm-picker-card--selected');
        card.removeAttribute('data-pnm-selected');
      }
    });
  }
  function handleTileSelection(trigger) {
    var payload = getTilePayload(trigger);
    if (!payload) return;
    var picks = load();
    if (filledCount(picks) >= PICK_LIMIT) {
      openPopup();
      return;
    }
    var slot = firstEmptySlot(picks);
    if (slot === -1) {
      openPopup();
      return;
    }
    picks[slot] = {
      id: Number(payload.id),
      title: (payload.title || '').trim(),
      variant_title: '',
      image: payload.image || '',
      handle: '',
      desc: payload.desc || '',
    };
    save(picks);
    BUS.fire('picks:changed');
    var searchHost = getSearchResultsContainer();
    if (
      searchHost &&
      searchHost.getAttribute('data-active') === 'true' &&
      searchHost.contains(trigger)
    ) {
      scrollPicksToSlot(slot);
    }
    clearExternalSearchWidgets();
  }
  function setupAdventTiles() {
    if (!isAdventMode()) return;
    injectAdventTileStyles();
    qsa('.pnm-picker-trigger').forEach(function (btn) {
      if (btn._pnmPickerBound) return;
      btn._pnmPickerBound = !0;
      if (btn.tagName === 'BUTTON' && !btn.hasAttribute('type'))
        btn.type = 'button';
      btn.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          handleTileSelection(btn);
        },
        !0
      );
    });
    updateTileSelections();
  }
  function getSearchInput() {
    if (searchInputEl && document.body && document.body.contains(searchInputEl))
      return searchInputEl;
    searchInputEl = document.getElementById('advent-picker-search');
    return searchInputEl;
  }
  function getSearchResultsContainer() {
    if (
      searchResultsEl &&
      document.body &&
      document.body.contains(searchResultsEl)
    )
      return searchResultsEl;
    searchResultsEl = document.getElementById('pnm-search-results');
    return searchResultsEl;
  }
  function primeSearchData() {
    if (searchPrefetching) return;
    searchPrefetching = !0;
    getScents().catch(function () {
      searchPrefetching = !1;
    });
  }
  function clearSearchResults() {
    var host = getSearchResultsContainer();
    if (!host) return;
    host.innerHTML = '';
    host.removeAttribute('data-active');
    host.removeAttribute('data-searching');
  }
  function resetSearchScrollPosition(el) {
    if (!el) return;
    var container = null;
    var node = el;
    while (node && node !== document) {
      if (node.classList && node.classList.contains('pnm-card__body')) {
        container = node;
        break;
      }
      node = node.parentNode;
    }
    if (!container && el.parentNode) {
      container = el.parentNode;
    }
    if (!container) return;
    try {
      if (typeof container.scrollTo === 'function') {
        container.scrollTo({ top: 0 });
        return;
      }
    } catch (_) {}
    try {
      container.scrollTop = 0;
    } catch (__) {}
  }
  function scrollPicksToSlot(slot) {
    if (slot == null || slot < 0) return;
    var container = qs('.pnm-card__body');
    if (!container) return;
    var selector = '#pnm-pk-list .pnm-item[data-slot="' + slot + '"]';
    var target = qs(selector, container) || qs(selector);
    if (!target) return;
    try {
      if (typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        return;
      }
    } catch (_) {}
    try {
      var targetRect = target.getBoundingClientRect();
      var containerRect = container.getBoundingClientRect();
      if (targetRect && containerRect) {
        var offset = targetRect.top - containerRect.top + container.scrollTop;
        container.scrollTop = offset;
      }
    } catch (__) {}
  }
  function clearExternalSearchWidgets() {
    try {
      clearSearchResults();
    } catch (_) {}
    try {
      var clearBtn = qs('.mz-clear-button');
      if (clearBtn) {
        clearBtn.click();
        return;
      }
    } catch (_) {}
    try {
      var input = qs('.mz-instant-search input');
      if (input) {
        input.value = '';
        try {
          input.dispatchEvent(new Event('input', { bubbles: !0 }));
        } catch (__) {
          try {
            if (document.createEvent) {
              var evt = document.createEvent('Event');
              evt.initEvent('input', !0, !0);
              input.dispatchEvent(evt);
            }
          } catch (___) {}
        }
      }
      try {
        if (
          typeof mz !== 'undefined' &&
          mz &&
          mz.suggest &&
          mz.suggest.$children &&
          mz.suggest.$children[1] &&
          typeof mz.suggest.$children[1].clearKeyword === 'function'
        ) {
          mz.suggest.$children[1].clearKeyword();
        }
      } catch (__) {}
      var clearBtn2 = qs('.mz-clear-button');
      if (clearBtn2 && clearBtn2.classList) {
        clearBtn2.classList.add('mz-hidden');
      }
    } catch (_) {}
  }
  function renderSearchStatus(message, host) {
    var container = host || getSearchResultsContainer();
    if (!container) return;
    if (message) {
      container.innerHTML =
        '<div class="pnm-search-results__status">' + esc(message) + '</div>';
      container.setAttribute('data-active', 'true');
      resetSearchScrollPosition(container);
    } else {
      container.innerHTML = '';
      container.removeAttribute('data-active');
    }
  }
  function renderSearchError() {
    var host = getSearchResultsContainer();
    if (!host) return;
    host.removeAttribute('data-searching');
    renderSearchStatus('Unable to load scents right now.', host);
  }
  function buildSearchResultMarkup(variant) {
    if (!variant || variant.id == null) return '';
    var idStr = String(variant.id);
    var title = cleanTitle(variant.title || '').trim();
    var variantTitle = variant.variant_title || '';
    var variantTitleDisplay = '';
    if (
      variantTitle &&
      String(variantTitle).toLowerCase() !== 'default title'
    ) {
      variantTitleDisplay = String(variantTitle);
    }
    if (!title) {
      title = variantTitleDisplay || 'Untitled scent';
    }
    var rawDesc =
      variant.scent_description || variant.desc || variant.description || '';
    var descFull = stripTags(rawDesc);
    var descPreview =
      descFull.length > 180 ? descFull.slice(0, 177).trim() + '…' : descFull;
    var image = variant.image || '';
    var dataAttrs =
      ' data-pnm-pick-id="' +
      escAttr(idStr) +
      '" data-pnm-pick-title="' +
      escAttr(title) +
      '" data-pnm-pick-image="' +
      escAttr(image) +
      '" data-pnm-pick-desc="' +
      escAttr(descFull) +
      '"';
    var imageMarkup = image
      ? '<div class="pnm-picker-card__image"><img src="' +
        escAttr(image) +
        '" alt=""></div>'
      : '';
    var variantMarkup = variantTitleDisplay
      ? '<div class="pnm-picker-card__variant">' +
        esc(variantTitleDisplay) +
        '</div>'
      : '';
    var descMarkup = descPreview
      ? '<div class="pnm-picker-card__desc">' + esc(descPreview) + '</div>'
      : '';
    return (
      '<div class="pnm-picker-card pnm-picker-card--selectable pnm-search-results__item"' +
      dataAttrs +
      '>' +
      '<button type="button" class="pnm-picker-trigger advent-scent"' +
      dataAttrs +
      '>' +
      '<div class="pnm-picker-card__inner">' +
      imageMarkup +
      '<div class="pnm-picker-card__text"><div class="pnm-picker-card__title">' +
      esc(title || '') +
      '</div>' +
      variantMarkup +
      descMarkup +
      '</div>' +
      '</div>' +
      '</button>' +
      '</div>'
    );
  }
  function renderSearchResults(query, matches) {
    var host = getSearchResultsContainer();
    if (!host) return;
    host.removeAttribute('data-searching');
    if (!query) {
      clearSearchResults();
      return;
    }
    var trimmed = String(query || '').trim();
    if (!trimmed) {
      clearSearchResults();
      return;
    }
    if (!matches || !matches.length) {
      renderSearchStatus('No scents found for “' + trimmed + '”.', host);
      return;
    }
    var limited = matches
      .slice(0, SEARCH_RESULT_LIMIT)
      .map(buildSearchResultMarkup)
      .filter(Boolean)
      .join('');
    host.innerHTML = limited;
    host.setAttribute('data-active', 'true');
    resetSearchScrollPosition(host);
    qsa('.pnm-picker-trigger', host).forEach(function (btn) {
      if (btn.tagName === 'BUTTON' && !btn.hasAttribute('type'))
        btn.type = 'button';
      btn.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          handleTileSelection(btn);
        },
        !0
      );
    });
    updateTileSelections(host);
  }
  function handleSearchInput(event) {
    var input = event && event.target ? event.target : getSearchInput();
    if (!input) return;
    var query = String(input.value || '');
    var trimmed = query.trim();
    var picks = load();
    if (filledCount(picks) >= PICK_LIMIT) {
      clearSearchResults();
      return;
    }
    if (!trimmed) {
      clearSearchResults();
      return;
    }
    var host = getSearchResultsContainer();
    if (host) {
      renderSearchStatus('Searching…', host);
      host.setAttribute('data-searching', 'true');
    }
    var token = ++searchRequestToken;
    var qLower = trimmed.toLowerCase();
    getScents()
      .then(function (all) {
        if (searchRequestToken !== token) return;
        var matches = (all || []).filter(function (variant) {
          if (!variant || variant.id == null) return !1;
          var fields = [
            cleanTitle(variant.title || ''),
            variant.variant_title || '',
            variant.scent_description ||
              variant.desc ||
              variant.description ||
              '',
          ];
          for (var i = 0; i < fields.length; i++) {
            var value = fields[i];
            if (!value) continue;
            if (String(value).toLowerCase().indexOf(qLower) !== -1) return !0;
          }
          return !1;
        });
        renderSearchResults(trimmed, matches);
      })
      .catch(function () {
        if (searchRequestToken !== token) return;
        renderSearchError();
      });
  }
  function syncSearchPlaceholder(count) {
    var input = getSearchInput();
    if (!input) return;
    var atLimit = count >= PICK_LIMIT;
    var desired = atLimit ? 'Remove a pick to search..' : 'Search scents...';
    if (input.getAttribute('placeholder') !== desired) {
      input.setAttribute('placeholder', desired);
    }
    if (atLimit) {
      if (input.value) {
        input.value = '';
      }
      searchRequestToken++;
      var host = getSearchResultsContainer();
      if (host) host.removeAttribute('data-searching');
      clearSearchResults();
    }
  }
  function scheduleScaffold() {
    if (scaffoldReady || scaffoldScheduled) return;
    scaffoldScheduled = !0;
    document.addEventListener('DOMContentLoaded', ensureScaffold);
  }
  function ensureScaffold() {
    if (scaffoldReady) return;
    if (!hasPickerHost()) {
      scheduleScaffold();
      return;
    }
    if (!document.body) {
      scheduleScaffold();
      return;
    }
    document.removeEventListener('DOMContentLoaded', ensureScaffold);
    scaffoldScheduled = !1;
    var pill = document.getElementById('pnm-picker-pill');
    if (!pill) {
      pill = document.createElement('div');
      pill.id = 'pnm-picker-pill';
      pill.className = 'pnm-pill';
      pill.innerHTML =
        '<span class="pnm-pill__label"><strong>Selected</strong> <span class="pnm-count__num" id="pnm-pk-count">0</span><span class="pnm-count__sep"> / </span><span class="pnm-count__num">' +
        REQUIRED +
        '</span></span>' +
        '<div class="pnm-pill__bar"><div class="pnm-pill__bar__in" id="pnm-pk-bar" style="width:0%"></div></div>' +
        '<button type="button" id="pnm-pk-view" class="pnm-btn pnm-btn--orange">View picks</button>';
      document.body.appendChild(pill);
    }
    var viewBtn = qs('#pnm-pk-view', pill || document);
    if (viewBtn && !viewBtn._pnmBound) {
      viewBtn._pnmBound = !0;
      viewBtn.addEventListener('click', openPopup, !0);
    }
    var modal = document.getElementById('pnm-picker-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'pnm-picker-modal';
      modal.className = 'pnm-modal';
      modal.innerHTML =
        '<div class="pnm-card" role="dialog" aria-modal="true" aria-labelledby="pnm-pk-title">' +
        '<div class="pnm-card__head">' +
        '<div class="pnm-card__title"><h2 id="pnm-pk-title">ADVENT PICKS</h2>' +
        '<span id="pnm-pk-count2" class="pnm-count"></span></div>' +
        '<button id="pnm-pk-close" class="pnm-btn pnm-card__close" type="button" aria-label="Close advent picks modal">Close..</button>' +
        '</div>' +
        '<div class="pnm-card__tools">' +
        '<div class="pnm-card__source">' +
        '<label for="pnm-random-source" class="pnm-label">Randomise from:</label>' +
        '<select id="pnm-random-source" class="pnm-dropdown">' +
        '<option value="little-wax-melts-all-scents">All Scents</option>' +
        '<option value="little-wax-melts-fruity">Fruity</option>' +
        '<option value="little-wax-melts-floral">Floral</option>' +
        '<option value="little-wax-melts-fresh">Fresh</option>' +
        '<option value="little-wax-melts-foody">Foody</option>' +
        '<option value="little-wax-melts-festive">Festive</option>' +
        '<option value="little-wax-melts-popular">Popular</option>' +
        '<option value="little-wax-melts-for-her">For Her</option>' +
        '<option value="little-wax-melts-for-him">For Him</option>' +
        '<option value="little-wax-melts-earthy">Earthy</option>' +
        '<option value="little-wax-melts-spa">Spa</option>' +
        '<option value="little-wax-melts-sweet-shop">Sweet Shop</option>' +
        '</select>' +
        '</div>' +
        '<div class="pnm-card__actions">' +
        '<button id="pnm-pk-random" type="button" class="pnm-btn pnm-btn--orange">Randomise</button>' +
        '<button id="pnm-pk-clear" type="button" class="pnm-btn pnm-btn--ghost">Reset</button>' +
        '<button id="pnm-pk-add" type="button" class="pnm-btn pnm-btn--orange pnm-card__add">Add to bag</button>' +
        '</div>' +
        '</div>' +
        '<input type="text" id="advent-picker-search" placeholder="Search scents..." class="advent-modal__search">' +
        '<div class="pnm-card__body">' +
        '<div id="pnm-search-results" class="pnm-search-results" aria-live="polite"></div>' +
        '<div class="pnm-board">' +
        '<div id="pnm-pk-list" class="pnm-list pnm-board__grid" role="list"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
      document.body.appendChild(modal);
      var sourceSel = modal.querySelector('#pnm-random-source');
      if (sourceSel && !sourceSel._pnmBound) {
        sourceSel._pnmBound = !0;
        sourceSel.addEventListener('change', function () {
          scentsCache = null;
          localStorage.setItem('pnm_randomise_source', this.value);
        });
      }
    }
    if (modal && !modal._pnmBackdropBound) {
      modal._pnmBackdropBound = !0;
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closePopup();
      });
    }
    var closeBtn = qs('#pnm-pk-close', modal || document);
    if (closeBtn && !closeBtn._pnmBound) {
      closeBtn._pnmBound = !0;
      closeBtn.addEventListener('click', closePopup, !0);
    }
    var clearBtn = qs('#pnm-pk-clear', modal || document);
    if (clearBtn && !clearBtn._pnmBound) {
      clearBtn._pnmBound = !0;
      clearBtn.addEventListener(
        'click',
        function () {
          scentsCache = null;
          save([]);
          BUS.fire('picks:changed');
        },
        !0
      );
    }
    var randomBtn = qs('#pnm-pk-random', modal || document);
    if (randomBtn && !randomBtn._pnmBound) {
      randomBtn._pnmBound = !0;
      randomBtn.addEventListener('click', randomiseIntoEmptySlots, !0);
    }
    var addBtn = qs('#pnm-pk-add', modal || document);
    if (addBtn && !addBtn._pnmBound) {
      addBtn._pnmBound = !0;
      addBtn.addEventListener('click', addBundleToBag, !0);
    }
    searchInputEl = document.getElementById('advent-picker-search');
    if (searchInputEl && !searchInputEl._pnmBound) {
      searchInputEl._pnmBound = !0;
      searchInputEl.addEventListener('input', handleSearchInput);
      searchInputEl.addEventListener('focus', primeSearchData, !0);
    }
    searchResultsEl = document.getElementById('pnm-search-results');
    updatePill();
    scaffoldReady = !0;
  }
  if (document.readyState === 'loading') scheduleScaffold();
  else if (typeof ensureScaffold !== 'undefined') {
    ensureScaffold();
  }
  function openPopup() {
    var m = qs('#pnm-picker-modal');
    if (m) {
      renderPopup();
      m.style.display = 'flex';
    }
  }
  function closePopup() {
    var m = qs('#pnm-picker-modal');
    if (m) {
      m.style.display = 'none';
    }
  }
  function bindRootEvents() {
    var root = document.getElementById('pnm-picker-root');
    if (!root || root._pnmEventsBound) return;
    root._pnmEventsBound = !0;
    root.addEventListener('pnm:open', function () {
      editContext = null;
      try {
        var input = document.getElementById('advent-picker-search');
        if (input) {
          input.value = '';
          input.dispatchEvent(new Event('input'));
        }
      } catch (_) {}
      openPopup();
    });
    root.addEventListener('pnm:edit', function (evt) {
      var detail = evt && evt.detail ? evt.detail : {};
      var parentKey = detail.key || '';
      var group = detail.group || '';
      var childKeys = [];
      if (Array.isArray(detail.childKeys)) childKeys = detail.childKeys;
      else if (typeof detail.childKeys === 'string') {
        try {
          var parsed = JSON.parse(detail.childKeys);
          if (Array.isArray(parsed)) childKeys = parsed;
        } catch (_) {}
      }
      editContext = {
        parentKey: parentKey,
        groupId: group,
        childKeys: childKeys,
      };
      try {
        var search = document.getElementById('advent-picker-search');
        if (search) {
          search.value = '';
          search.dispatchEvent(new Event('input'));
        }
      } catch (_) {}
      var ids = parseSelectedScents(detail.scents || '');
      if (!ids.length) {
        save([]);
        BUS.fire('picks:changed');
        openPopup();
        return;
      }
      loadPicksForIds(ids)
        .then(function () {
          openPopup();
        })
        .catch(function () {
          openPopup();
        });
    });
  }
  function updatePill() {
    var n = filledCount(load());
    var c = qs('#pnm-pk-count');
    if (c) c.textContent = n;
    var b = qs('#pnm-pk-bar');
    if (b) b.style.width = Math.min(100, (n / REQUIRED) * 100) + '%';
    var c2 = qs('#pnm-pk-count2');
    if (c2)
      c2.innerHTML =
        '<span class="pnm-count__num">' +
        n +
        '</span><span class="pnm-count__sep"> / </span><span class="pnm-count__num">' +
        REQUIRED +
        '</span>';
    syncSearchPlaceholder(n);
  }
  function renderPopup() {
    var list = qs('#pnm-pk-list');
    if (!list) return;
    var picks = load();
    list.innerHTML = picks
      .map(function (p, i) {
        var hasPick = !!p;
        var visual =
          hasPick && p.image
            ? '<img class="pnm-item__image" alt="" src="' + p.image + '">'
            : '<div class="pnm-item__placeholder" aria-hidden="true"><span>' +
              (i + 1) +
              '</span></div>';
        var displayTitle = hasPick ? cleanTitle(p.title).trim() : '';
        var descMarkup =
          hasPick && p.desc
            ? '<details class="pnm-acc pnm-item__acc"><summary class="pnm-acc__sum"><svg class="pnm-caret" viewBox="0 0 10 6" aria-hidden="true" focusable="false" width="10" height="6"><path d="M1 1.25l4 3.5 4-3.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>Scent Description</summary><div class="pnm-acc__body pnm-scent-body pnm-scent-body--picker">' +
              esc(p.desc) +
              '</div></details>'
            : '';
        var removeMarkup = hasPick
          ? '<button type="button" class="pnm-btn pnm-btn--ghost pnm-item__remove" data-rm-slot="' +
            i +
            '">Remove</button>'
          : '';
        var titleText = displayTitle || 'Empty slot';
        return (
          '<div class="pnm-item' +
          (hasPick ? '' : ' pnm-item--empty') +
          '" role="listitem" data-slot="' +
          i +
          '" draggable="' +
          (hasPick ? 'true' : 'false') +
          '">' +
          '<div class="pnm-item__window">' +
          visual +
          '<span class="pnm-item__badge">' +
          (i + 1) +
          '</span></div>' +
          '<div class="pnm-item__info">' +
          '<div class="pnm-item__day">Day ' +
          (i + 1) +
          '</div>' +
          '<div class="pnm-item__title">' +
          titleText +
          '</div>' +
          descMarkup +
          removeMarkup +
          '</div>' +
          '</div>'
        );
      })
      .join('');
    qsa('[data-rm-slot]', list).forEach(function (btn) {
      btn.addEventListener(
        'click',
        function () {
          var slot = parseInt(this.getAttribute('data-rm-slot'), 10);
          if (isNaN(slot)) return;
          var arr = load();
          if (slot >= 0 && slot < arr.length) {
            arr[slot] = null;
            save(arr);
            BUS.fire('picks:changed');
          }
        },
        !0
      );
    });
    qsa('.pnm-item', list).forEach(function (item) {
      item.addEventListener('dragstart', function (e) {
        if (this.classList.contains('pnm-item--empty')) {
          e.preventDefault();
          return;
        }
        e.dataTransfer.setData('text/plain', this.dataset.slot);
        e.dataTransfer.effectAllowed = 'move';
      });
      item.addEventListener('dragover', function (e) {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
      });
      item.addEventListener('drop', function (e) {
        e.preventDefault();
        var from = parseInt(e.dataTransfer.getData('text/plain'), 10);
        var to = parseInt(this.dataset.slot, 10);
        if (isNaN(to)) return;
        if (!isNaN(from)) {
          if (from === to) return;
          var picks = load();
          if (!picks[from]) return;
          var moved = clonePick(picks[from]) || picks[from];
          picks[to] = moved;
          picks[from] = null;
          save(picks);
          BUS.fire('picks:changed');
        } else {
          var raw =
            e.dataTransfer.getData('application/json') ||
            e.dataTransfer.getData('text/pnm-pick');
          if (raw) {
            try {
              var payload = JSON.parse(raw);
              if (payload && payload.id != null) {
                var current = load();
                current[to] = clonePick(payload) || {
                  id: payload.id,
                  title: payload.title || payload.name || '',
                  variant_title: payload.variant_title || '',
                  image: payload.image || '',
                  handle: payload.handle || payload.product_handle || '',
                  desc:
                    payload.desc ||
                    payload.scent_description ||
                    payload.description ||
                    '',
                };
                save(current);
                BUS.fire('picks:changed');
              }
            } catch (_) {}
          }
        }
      });
    });
  }
  BUS.on('picks:changed', function () {
    updatePill();
    updateTileSelections();
    updateTileSelections(getSearchResultsContainer());
    var modal = qs('#pnm-picker-modal');
    if (modal && modal.style.display === 'flex') renderPopup();
    applyRandomisingAnimation();
  });
  function interceptCollectionAdds() {
    if (!isAdventMode()) return;
    qsa('form[action*="/cart/add"]').forEach(function (f) {
      if (f._pnmBound) return;
      f._pnmBound = !0;
      f.addEventListener(
        'submit',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          var id = (f.querySelector('[name="id"]') || {}).value;
          if (!id) return;
          var title = cleanTitle(
            (f.closest('[data-product-title]') || {}).dataset.productTitle || ''
          );
          var picks = load();
          if (filledCount(picks) >= PICK_LIMIT) {
            openPopup();
            return;
          }
          var slot = firstEmptySlot(picks);
          if (slot === -1) {
            openPopup();
            return;
          }
          picks[slot] = {
            id: Number(id),
            title: title.trim(),
            variant_title: '',
            image: '',
            handle: '',
            desc: '',
          };
          save(picks);
          BUS.fire('picks:changed');
        },
        !0
      );
    });
  }
  function markSlotsLoading() {
    var list = qs('#pnm-pk-list');
    if (!list) return;
    qsa('.pnm-item', list).forEach(function (item) {
      item.classList.add('pnm-item--loading');
    });
  }
  function applyRandomisingAnimation() {
    if (!randomisingAnimation) return;
    var slots = Array.isArray(randomisingAnimation.slots)
      ? randomisingAnimation.slots
      : [];
    randomisingAnimation = null;
    var list = qs('#pnm-pk-list');
    if (!list) return;
    qsa('.pnm-item', list).forEach(function (item) {
      item.classList.remove('pnm-item--loading');
    });
    if (!slots.length) return;
    requestAnimationFrame(function () {
      slots.forEach(function (slot) {
        var node = list.querySelector('.pnm-item[data-slot="' + slot + '"]');
        if (!node) return;
        node.classList.add('pnm-item--enter');
        var finished = !1;
        var clear = function (e) {
          if (finished) return;
          if (e && e.target !== node) return;
          finished = !0;
          node.classList.remove('pnm-item--enter');
          node.removeEventListener('animationend', clear);
        };
        node.addEventListener('animationend', clear);
        setTimeout(clear, 700);
      });
    });
  }
  function scentsUrlCandidates() {
    return ['/collections/little-wax-melts-all-scents?view=advent-variants'];
  }
  function getScents() {
    if (scentsCache) return Promise.resolve(scentsCache);
    var sel = (function () {
      try {
        var dd = document.getElementById('pnm-random-source');
        if (dd && dd.value) return dd.value;
        var s = localStorage.getItem('pnm_randomise_source');
        if (s) return s;
      } catch (_) {}
      return 'little-wax-melts-all-scents';
    })();
    var base = '/collections/' + sel + '?view=advent-variants';
    var page = 1,
      out = [];
    function loop() {
      return fetch(base + '&page=' + page, { credentials: 'same-origin' })
        .then((r) => r.text())
        .then((txt) => {
          var j = null;
          try {
            j = JSON.parse(txt);
          } catch (_) {}
          var arr = j && Array.isArray(j.variants) ? j.variants : [];
          if (arr.length === 0) {
            scentsCache = out;
            return out;
          }
          out = out.concat(arr);
          page++;
          return loop();
        })
        .catch((_) => {
          scentsCache = out;
          return out;
        });
    }
    return loop();
  }
  function randomiseIntoEmptySlots() {
    markSlotsLoading();
    getScents()
      .then(function (all) {
        var byId = {};
        all.forEach(function (v) {
          if (v && v.id) byId[String(v.id)] = v;
        });
        var picks = load();
        var have = new Set(
          picks.filter(Boolean).map(function (p) {
            return String(p.id);
          })
        );
        var emptySlots = [];
        for (var idx = 0; idx < REQUIRED; idx++) {
          if (!picks[idx]) emptySlots.push(idx);
        }
        var pool = Object.keys(byId)
          .map((k) => byId[k])
          .filter((v) => v.available && !have.has(String(v.id)));
        for (var i = pool.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = pool[i];
          pool[i] = pool[j];
          pool[j] = tmp;
        }
        var need = Math.max(0, emptySlots.length);
        var updatedSlots = [];
        for (var k = 0; k < need && k < pool.length; k++) {
          var c = pool[k];
          var cleaned = cleanTitle(c.title);
          var targetSlot = emptySlots[k];
          if (typeof targetSlot === 'number') {
            picks[targetSlot] = {
              id: c.id,
              title: cleaned.trim(),
              variant_title: c.variant_title || '',
              image: c.image || '',
              handle: c.product_handle || '',
              desc: c.scent_description || '',
            };
            updatedSlots.push(targetSlot);
          }
        }
        save(picks);
        randomisingAnimation = { slots: updatedSlots };
        BUS.fire('picks:changed');
        openPopup();
      })
      .catch(function () {
        randomisingAnimation = null;
        var list = qs('#pnm-pk-list');
        if (list)
          qsa('.pnm-item', list).forEach(function (item) {
            item.classList.remove('pnm-item--loading');
          });
      });
  }
  function resolveParentVariantId() {
    return new Promise(function (res) {
      var id = null,
        handle = 'advent-calendar-pick-your-own';
      try {
        var root = document.getElementById('pnm-picker-root');
        if (root) {
          var d = root.getAttribute('data-parent-variant-id');
          if (d) id = Number(d);
          var h = root.getAttribute('data-parent-handle');
          if (h) handle = h;
        }
      } catch (_) {}
      if (id) {
        res(id);
        return;
      }
      fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then((r) => r.json())
        .then((p) => {
          try {
            var vid =
              p.variants && p.variants[0] && p.variants[0].id
                ? Number(p.variants[0].id)
                : null;
            res(vid);
          } catch (e) {
            res(null);
          }
        })
        .catch((_) => res(null));
    });
  }
  function changeCart(payload) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'same-origin',
    }).then(function (r) {
      if (!r.ok) throw new Error('change');
      return r.json();
    });
  }
  function addCartItems(payload) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'same-origin',
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      return r.json();
    });
  }
  function removeChildItems(childKeys) {
    if (!Array.isArray(childKeys) || !childKeys.length) {
      return Promise.resolve();
    }
    var tasks = childKeys.map(function (key) {
      if (!key) return Promise.resolve();
      return changeCart({ id: key, quantity: 0 }).catch(function () {
        return Promise.resolve();
      });
    });
    return Promise.all(tasks).then(function () {
      return;
    });
  }
  function addChildItems(group, chosen) {
    if (!Array.isArray(chosen) || !chosen.length) return Promise.resolve();
    var items = [];
    chosen.forEach(function (entry) {
      if (!entry || !entry.pick || entry.pick.id == null) return;
      items.push({
        id: Number(entry.pick.id),
        quantity: 1,
        properties: { 'Advent group': group, _advent_child: '1' },
      });
    });
    if (!items.length) return Promise.resolve();
    return addCartItems({ items: items });
  }
  function updateExistingBundle(group, props, chosen) {
    if (!editContext || !editContext.parentKey) {
      alert('Could not update picks.');
      return;
    }
    var parentKey = editContext.parentKey;
    var childKeys = Array.isArray(editContext.childKeys)
      ? editContext.childKeys
      : [];
    changeCart({ id: parentKey, quantity: 1, properties: props })
      .then(function () {
        return removeChildItems(childKeys);
      })
      .then(function () {
        return addChildItems(group, chosen);
      })
      .then(function () {
        try {
          localStorage.removeItem(KEY);
        } catch (_) {}
        editContext = null;
        BUS.fire('picks:changed');
        document.dispatchEvent(new CustomEvent('pnm:advent-refresh'));
        window.location.reload();
      })
      .catch(function () {
        alert('Could not update picks.');
      });
  }
  function addBundleToBag() {
    var picks = load();
    var chosen = filledEntries(picks);
    if (chosen.length < REQUIRED) {
      openPopup();
      return;
    }
    var isEditing = !!(editContext && editContext.parentKey);
    var group =
      isEditing && editContext.groupId
        ? editContext.groupId
        : 'adv-' + Date.now();
    var props = {
      'Advent group': group,
      Version: 'PNM Picker v1',
      'Selected Scents': buildSelectedScentsPayload(chosen),
    };
    chosen.forEach(function (entry) {
      props['Pick ' + (entry.slot + 1)] = cleanTitle(entry.pick.title).trim();
    });
    if (isEditing) {
      updateExistingBundle(group, props, chosen);
      return;
    }
    resolveParentVariantId().then(function (parentId) {
      var parentVariantId = Number(parentId);
      if (!parentVariantId) {
        alert('Advent calendar product not configured.');
        return;
      }
      var items = [];
      items.push({ id: parentVariantId, quantity: 1, properties: props });
      chosen.forEach(function (entry) {
        items.push({
          id: Number(entry.pick.id),
          quantity: 1,
          properties: { 'Advent group': group, _advent_child: '1' },
        });
      });
      addCartItems({ items: items })
        .then(function () {
          try {
            localStorage.removeItem(KEY);
          } catch (_) {}
          BUS.fire('picks:changed');
          // Discounts are now applied automatically, redirect directly to cart
          window.location.href = '/cart';
        })
        .catch(function () {
          alert('Could not add picks to bag.');
        });
    });
  }
  function init() {
    if (!hasPickerHost()) return;
    if (typeof ensureScaffold !== 'undefined') {
      ensureScaffold();
    }
    bindRootEvents();
    BUS.fire('picks:changed');
  }
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('pageshow', init, !0);
  document.addEventListener('shopify:section:load', init, !0);
})();
